module.exports = __webpack_public_path__ + "img/检查项.1ea73381.png";